<script>
  import { Link } from "svelte-routing";
  import Icon from "./Icon.svelte";

  export let links;
  export let nightTheme = false;
  export let keepSelected = false;

  const getProps = ({ location, href, isPartiallyCurrent, isCurrent }) => {
    const isActive = href === "/" ? isCurrent : isPartiallyCurrent || isCurrent;

    // The object returned here is spread on the anchor element's attributes
    if (isCurrent || (keepSelected && isActive)) {
      return { class: "vertical-nav active" };
    }
    return { class: "vertical-nav" };
  };
</script>

<div class="vertical-nav-wrapper">
  {#each links.filter((link) => !!link) as link (link.to)}
    <Link to={link.to} {getProps}>
      {#if link.icon}
        <div class="nav-item">
          <Icon
            icon={link.icon}
            medium
            inline
            fill={nightTheme ? "white" : "var(--night)"}
          />
          <div class="label">{link.label}</div>
        </div>
      {:else}{link.label}{/if}
    </Link>
  {/each}
</div>

<style>
  .vertical-nav-wrapper {
    margin: 24px 0;
  }

  .nav-item {
    display: flex;
    align-items: center;
  }

  .nav-item > * + * {
    margin-left: 12px;
  }

  .label {
    margin-left: 12px;
  }
</style>
